<template>
   <el-dialog
        title=""
        :visible.sync="showComponent"
        center>
        <span>{{$t('vip.payMentComplete')}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog(0);">{{$t('vip.cancel')}}</el-button>
            <el-button type="primary" @click="closeDialog(1)">{{$t('vip.sure')}}</el-button>
        </span>
    </el-dialog>
</template>
<style scoped>
    >>>.el-dialog{
        max-width: 360px;
        min-width: 225px;
    }
</style>
<script>
  export default {
    name: "AlertComponent",
    data() {
      return {
          showComponent:false,
          obj:{}
      };
    },
    mounted (){

    },
    created(){

    },
    methods: {
        closeDialog:function(type){
            this.$emit('getCloseType',{type:type,item:this.payOver});
            this.showComponent = false;
        },
        show:function(obj){
            this.payOver = obj['item'] || {};
            this.showComponent = true;
        },
        hide:function(){
            this.showComponent = false;
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/alertComponent.vue